// extracted by mini-css-extract-plugin
export default {"tabsFlewView":"Tabs_tabsFlewView__xCIID"};